import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AssessmentMockService } from '../services/assessment-mock.service';
import { ASSESSMENT_PRICE } from '../data/assessment.seed';

declare var Stripe: any;

@Component({
  selector: 'app-assessment-pay',
  templateUrl: './assessment-pay.component.html',
  styleUrls: ['./assessment-pay.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AssessmentPayComponent implements OnInit, AfterViewInit, OnDestroy {
  token!: string;
  price = ASSESSMENT_PRICE;
  cardComplete = false;
  cardError = '';
  payError = '';
  processing = false;
  private stripe: any;
  private card: any;

  constructor(private route: ActivatedRoute, private router: Router, private svc: AssessmentMockService) {}

  ngOnInit(): void { this.token = this.route.snapshot.paramMap.get('token')!; }

  ngAfterViewInit(): void {
    this.stripe = Stripe(environment.stripe_api_key);
    this.card = this.stripe.elements().create('card', {
      style: { base: { fontSize: '15px', color: '#3a3f44', '::placeholder': { color: '#9aa0a6' } } },
    });
    this.card.mount('#asmt-card-element');
    this.card.on('change', (ev: any) => {
      this.cardComplete = ev.complete;
      this.cardError = ev.error?.message ?? '';
    });
  }

  ngOnDestroy(): void { this.card?.destroy(); }

  pay(): void {
    if (!this.cardComplete || this.processing) { return; }
    this.processing = true;
    this.payError = '';
    // Real client-side Stripe call (validation/branding are genuinely Stripe's).
    // Swap-in seam: with a backend PaymentIntent this becomes stripe.confirmCardPayment(clientSecret, …).
    this.stripe.createPaymentMethod({ type: 'card', card: this.card }).then((res: any) => {
      this.processing = false;
      if (res.error) { this.payError = res.error.message; return; }
      this.svc.recordPayment(this.token);
      this.router.navigate(['/assessments', this.token, 'q']);
    });
  }
}
